import { toast } from 'react-toastify';

// export const handleUrlBannerChange = useCallback((value, setUrlBannerValid, setUrlValidationMessage) => {
export const handleUrlBannerChange = ((value, setUrlBannerValid, setUrlValidationMessage) => {
  if (value === '') {
    setUrlBannerValid(true);
    setUrlValidationMessage('');
    return true;
  }
  if (value.length > 2048) {
    toast.error('A URL da imagem é muito longa');
    setUrlBannerValid(false);
    setUrlValidationMessage('A URL da imagem é muito longa');
    // setUrlBanner('');
    return false;
  }
  if (!(/\.(jpg|jpeg|png|gif|webp)$/i.test(value))) {
    toast.error('A URL deve terminar com .jpg, .jpeg, .png, .webp ou .gif');
    setUrlBannerValid(false);
    setUrlValidationMessage('A URL deve terminar com .jpg, .jpeg, .png, .webp ou .gif');
    // setUrlBanner('');
    return false;
  }
  // setUrlBanner(value);
  setUrlBannerValid(true);
  // setHasChanges(true);
  return true;
})